import AddressLocationFields from '../components/AddressLocationFields';
import { useState } from 'react'
import { useDispatch, useSelector }  from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { saveShippingAddress } from '../slices/cartSlice.js'

function ShippingScreen() {

    const cart = useSelector((state) => state.cart)
    const { shippingAddress } = cart

    const [address, setAddress] = useState(shippingAddress?.address || '')
    const [city, setCity] = useState(shippingAddress?.city || '')
    const [postalCode, setPostalCode] = useState(shippingAddress?.postalCode || '')
    const [country, setCountry] = useState(shippingAddress?.country || '')

    const navigate = useNavigate()
    const dispatch = useDispatch()

   
    function submitHandler(e){
        e.preventDefault()
        dispatch(saveShippingAddress({ address, city, postalCode, country }))
        navigate('/payment')
    }

    return (
      <section className='mx-auto w-full max-w-2xl'>
        <div className='rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8'>
          <p className='mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-sky-700'>
            Checkout
          </p>
          <h1 className='mb-6 text-3xl font-semibold text-slate-900'>Shipping</h1>

          <form onSubmit={submitHandler} className='space-y-4'>
            <div>
              <label htmlFor='address' className='mb-1.5 block text-sm font-medium text-slate-700'>
                Address
              </label>
              <input
                id='address'
                type='text'
                placeholder='Enter address'
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                className='w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm text-slate-800 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-2 focus:ring-sky-100'
              />
            </div>

            <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
              <div>
                <label htmlFor='postalCode' className='mb-1.5 block text-sm font-medium text-slate-700'>
                  Postal Code
                </label>
                <input
                  id='postalCode'
                  type='text'
                  placeholder='Enter postal code'
                  value={postalCode}
                  onChange={(e) => setPostalCode(e.target.value)}
                  className='w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm text-slate-800 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-2 focus:ring-sky-100'
                />
              </div>
            </div>

            <AddressLocationFields country={country} city={city} setCountry={setCountry} setCity={setCity} />

            <button
              type='submit'
              className='inline-flex items-center justify-center rounded-xl bg-sky-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-sky-700'
            >
              Continue
            </button>
          </form>
        </div>
      </section>
    )
}

export default ShippingScreen
